module.exports = __webpack_public_path__ + "media/images/spinner-8bd248d0e905e52d23a88fe58f607643.svg";